import React, {Component} from 'react';
import {observer} from "mobx-react";

class Image extends Component {
  render() {
    if(this.props.value) {

      let realPath="";
      let previewPath="";
      if(typeof this.props.value === "object") {
        if (this.props.value.real) {
          realPath = this.props.value.real;
        }
        if (this.props.value.evapreview) {
          previewPath=this.props.value.evapreview;
        }
      } else {
        const newCode = this.props.field.code + '_evapreview';
        previewPath = this.props.row[newCode] || this.props.value;
      }

      if(previewPath) {
        return (
          <img onClick={(e) => {
            e.stopPropagation();
          }} src={previewPath}/>
        );
      }


/*
      const newCode=this.props.field.code+'_evapreview';
      if(this.props.row[newCode]) {
        return (
          <img onClick={(e)=>{ e.stopPropagation(); }} src={this.props.row[newCode]} />
        );
      } else {
        return (
          <img onClick={(e)=>{ e.stopPropagation(); }} src={`/autoresize/evapreview${this.props.value}`}/>
        );
      }*/
    }
    return null;
  }
}

export default observer(Image);